import { BasicOptionModel, IBasicOption } from "@core/models";

export const locationMocks = [
  new BasicOptionModel({ [IBasicOption.id]: 28833, [IBasicOption.name]: "Paris" }),
  new BasicOptionModel({ [IBasicOption.id]: 28850, [IBasicOption.name]: "Paris 15\u00e8me" }),
  new BasicOptionModel({ [IBasicOption.id]: 28844, [IBasicOption.name]: "Paris 9\u00e8me" }),
  new BasicOptionModel({ [IBasicOption.id]: 28851, [IBasicOption.name]: "Paris 16\u00e8me" }),
  new BasicOptionModel({ [IBasicOption.id]: 28852, [IBasicOption.name]: "Paris 17\u00e8me" }),
];
